import { createContext, PropsWithChildren } from 'react';
import { useHeaderManager } from '@/providers/HeaderContextProvider/HeaderContextProvider.hooks';
import { IHeaderContext } from '@/providers/HeaderContextProvider/HeaderContextProvider.types';

export const HeaderContext = createContext<Partial<IHeaderContext>>({});

export const HeaderProvider = ({ children }: PropsWithChildren) => {
  const VALUE = useHeaderManager();

  return <HeaderContext.Provider value={VALUE}>{children}</HeaderContext.Provider>;
};
